import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import useUserRole from '../../hooks/useUserRole';
import { useAdmin } from '../../contexts/AdminContext';

const ProtectedAdminRoute = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { userRole, loading } = useUserRole();
  const { isAdmin, isAdminMode } = useAdmin();


  // Verificar si está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Mostrar loading mientras se obtiene el rol
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verificando permisos...</p>
        </div>
      </div>
    );
  }

  // Verificar si es administrador y está en modo admin
  if (!isAdmin || !isAdminMode) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
